import { useEffect, useRef } from 'react';

/**
 * Publishes the height of the element the returned ref points at as the CSS variable `name` on <html> (e.g.
 * --nav-inset), and follows it, so fixed layers such as toasts sit above that element. Removed on unmount.
 */
export function useInsetVariable<T extends HTMLElement>(name: string) {
  const ref = useRef<T>(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const root = document.documentElement;
    const observer = new ResizeObserver(([entry]) => {
      const height = entry?.borderBoxSize[0]?.blockSize;
      if (height !== undefined) root.style.setProperty(name, `${height}px`);
    });
    observer.observe(element, { box: 'border-box' });
    return () => {
      observer.disconnect();
      root.style.removeProperty(name);
    };
  }, [name]);
  return ref;
}
